import { render } from "./ProviderIcon.vue?vue&type=template&id=00431226"
import script from "./ProviderIcon.vue?vue&type=script&lang=js"
export * from "./ProviderIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__